import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SecondaryButton } from 'src/components/shared/Button/Button';
import { Divider } from 'src/components/shared/Divider/Divider';
import { Autocomplete } from 'src/components/shared/Forms/Autocomplete/Autocomplete';
import { InputField } from 'src/components/shared/Forms/Input/InputField';
import {
  HeaderSection,
  HeaderSectionLeft
} from 'src/components/shared/HeaderSection/HeaderSection';
import { Header1 } from 'src/components/shared/Typography/Header1';
import { selectRecipients } from 'src/store/recipients/recipients.selectors';
import { download, getFileNameFromHeader } from 'src/utils/download';

export const CertificatesPage = () => {
  const { t } = useTranslation();
  const [showExportSpinner, setShowExportSpinner] = useState<boolean>(false);
  const [orderNo, setOrderNo] = useState<number>();
  const [recipientId, setRecipientId] = useState<number>();

  const onOrderNoChange = (event: any) => {
    setOrderNo(event.target.value);
  };

  const recipients$ = useSelector(selectRecipients);

  const onExport = async () => {
    setShowExportSpinner(true);
    await axios({
      method: 'GET',
      responseType: 'arraybuffer',
      url: `/products/certificate/${orderNo}/${recipientId}`
    })
      .then(response => {
        const disposition = response.headers['content-disposition'];
        const contentType = response.headers['content-type'];
        const filename = getFileNameFromHeader(disposition);
        const blob = new Blob([response.data as Blob], {
          type: contentType
        });
        download(filename, blob);
      })
      .catch(() => {});
    setShowExportSpinner(false);
  };

  return (
    <>
      <HeaderSection className="mb-32">
        <HeaderSectionLeft>
          <Header1>{t('certificate.singular')}</Header1>
          <Divider />
          <InputField
            name="orderNo"
            value={orderNo}
            label={t('product.orderNo')}
            onChange={onOrderNoChange}
          />
          <Autocomplete
            options={recipients$}
            label={t('recipient.singular')}
            optionField="name"
            onChange={recipient => {
              setRecipientId(recipient?.id);
            }}
          />
          <SecondaryButton
            onClick={onExport}
            loading={showExportSpinner}
            icon="la-file-excel"
            className="mr-32"
            disabled={!orderNo || !recipientId}
          >
            {`${t('export.excel')}`}
          </SecondaryButton>
        </HeaderSectionLeft>
      </HeaderSection>
    </>
  );
};
